export const SECURITY_QUESTIONS = "/epms/api/v1/admin/securityquestion";
export const REGISTRATION = "/epms/api/v1/admin/register";
export const LOGIN = "/epms/api/v1/admin/authenticate";
export const OTPS = "/epms/api/v1/admin/otps";
export const DEPARTMENTS = "/epms/api/v1/admin/departments";
export const VERIFYOTP = "/epms/api/v1/admin/verifyotps";
export const ADMINOTPS = "/epms/api/v1/admin/adminotps";
export const LOGOUT = "/epms/api/v1/admin/logout";
export const GETACTIVEUSER = "/epms/api/v1/admin/alloasusers";
export const SESSION_HEARTBEAT = "/epms/api/v1/admin/sessionheartbeat";
export const GETROLES = "/epms/api/v1/admin/roles";
export const GETSUPERVISOR = "/epms/api/v1/admin/supervisors";
export const ADDUSER = "/epms/api/v1/admin/adduser";
export const UPDATEUSERREQUEST = "/epms/api/v1/admin/updateadduser";
export const DELETEUSERREQUEST = "/epms/api/v1/admin/canceluserapproval";
export const GETAPPROVALUSER = "/epms/api/v1/admin/useroasapproval";
export const APPROVALUSER = "/epms/api/v1/admin/approvaluser";
export const VERIFY_USER = "/epms/api/v1/admin/verifyuser";
export const UPDATE_VERIFY_USER = "/epms/api/v1/admin/updatemobileemailverify";
export const VERIFICATIONOTP_FOR_USERVERIFY =
  "/epms/api/v1/verifyotpsforverifieduser";
export const API_REPO_VERSION = "/epms/api/v1/admin/version";
export const FORGETPASSWORD = "/epms/api/v1/admin/forgotpassword";
export const RESETPASSWORD = "/epms/api/v1/admin/resetpassword";
export const CHANGE_PASSWORD = "/epms/api/v1/admin/changepassword";
export const RESET_PASSWORD =
  "/epms/api/v1/admin/resetpasswordforfirsttimelogin";
export const CHECK_USER = "/epms/api/v1/admin/isvaliddepartment";
export const GETADVERTISEMENT = "/epms/api/v1/admin/alladvertisements";
export const GETPASTADVERTISEMENT = "/epms/api/v1/admin/allpastadvertisements";
export const GETCHALLANDETAILS = "/epms/api/v1/admin/advertisements/";
export const GETCHALLANCANDIDATES = "/epms/api/v1/admin/advertisements/";
export const UPLOADCHALLANDETAILS = "/epms/api/v1/admin/uploadchallandetails";
export const SENDCHALLANDETAILSTOBANK =
  "/epms/api/v1/admin/sendchallandetailstobank";
export const CANDIDATEDOCUMENTDETAILS =
  "/epms/api/v1/admin/candidatedocumentdetails/";
export const UPDATEDOCUMNENTSINFO = "/epms/api/v1/admin/updatedocumnentsinfo/";
export const DOWNLOAD_DOCUMENT = "/epms/api/v1/admin/downloadrequireddocuments";
export const OASUSERS = "/epms/api/v1/admin/oasusers/";
export const ADDDOCFORAPPROVAL = "/epms/api/v1/admin/adddocforapproval";
export const DOCAPPROVAL = "/epms/api/v1/admin/docapproval/";
export const DOCUMENTAPPROVAL = "/epms/api/v1/admin/docapproval";
export const GETAPPLICATIONDETAILS_BY_ADVERTISEMENT =
  "/epms/api/v1/admin/getapplicationdetailsbyadvertisement/";
export const ADVERTISEMENT_DETAILS =
  "/epms/api/v1/admin/getadvertisementsdetails";
export const CANDIDATE_DOC_DOWNLOAD = "/epms/api/v1/admin/candidateDocument";
export const PAST_ADVERTISEMENT_DETAILS =
  "/epms/api/v1/admin/allpastadvertisements";
export const ADVERTISEMENT_DOC_DOWNLOAD =
  "/epms/api/v1/admin/downloadalldocuments";
export const APPROVALACTIONSHISTORY = "/epms/api/v1/admin/docapprovalactions/";
export const ALLACTIVEADVERTISEMENT =
  "/epms/api/v1/admin/allactiveadvertisements";
export const ALLPASTADVERTISEMENT = "/epms/api/v1/admin/allpastadvertisements";
export const DOWNLOADBANKFILE = "/epms/api/v1/admin/downloadbankfile";
export const SEARCHCANDIDATE = "/epms/api/v1/admin/searchcandidate";
export const LOOKUP_OPTION = "/epms/api/v1/admin/lookupoption";
export const ADVERTISEMENT = "/epms/api/v1/admin/advertisements";
export const CHECK_ELIGIBILITY = "/epms/api/v1/admin/checkeligibility";
export const MERGED_PROFILE_INFO_DISPLAY =
  "/epms/api/v1/admin/profilecreationmergeddraft";
export const PROFILE_INFO_DISPLAY = "/epms/api/v1/admin/profilecreationdraft";
export const STATES = "/epms/api/v1/admin/state";
export const GET_ALL_STAGES_LIST = "/epms/api/v1/admin/stages";
export const GET_UNIVERSITY = "/epms/api/v1/admin/university";
export const EDIT_UNIVERSITY = "/epms/api/v1/admin/university";
export const ADD_UNIVERSITY = "/epms/api/v1/admin/university";
export const UNIVERSITY_STATES = "/epms/api/v1/admin/states";
export const MANAGE_UNIVERSITY = "/epms/api/v1/admin/university/manage";
export const GET_UNIVERSITIES = "/epms/api/v1/admin/university/search";
export const GET_All_MODULES = "/epms/api/v1/admin/lookupoption/module";
export const GET_ALL_TYPES = "/epms/api/v1/admin/lookupoption/type";
export const GET_LOOKUP_OPTIONS = "/epms/api/v1/admin/lookupoption/search";
export const MANAGE_LOOKUP_OPTION = "/epms/api/v1/admin/lookupoption/manage";
export const ADD_LOOKUP_OPTION = "/epms/api/v1/admin/lookupoption";
export const EDIT_LOOKUP_OPTION = "/epms/api/v1/admin/lookupoption";
export const GET_LOOKUP_OPTION = "/epms/api/v1/admin/lookupoption";
export const GET_ALL_PARENT_LABELS = "/epms/api/v1/admin/lookupoption/parent";
export const GET_ALL_PARENT_TYPE = "/epms/api/v1/admin/lookupoption/parent";
export const SEARCH_STATES = "/epms/api/v1/admin/state";
export const GET_ALL_STATES = "/epms/api/v1/admin/states";
export const GET_STATE_BY_ID = "/epms/api/v1/admin/state";
export const ADD_STATE_DATA = "/epms/api/v1/admin/state/";
export const EDIT_STATE_DATA = "/epms/api/v1/admin/state/";
export const MANAGE_STATE_DATA = "/epms/api/v1/admin/state/manage";
export const GET_ALL_DISTRICT_SEARCH = "/epms/api/v1/admin/district/search";
export const GET_ALL_DISTRICT = "/epms/api/v1/admin/district";
export const GET_DISTRICT = "/epms/api/v1/admin/district";
export const GET_DISTRICT_STATES = "/epms/api/v1/admin/states";
export const MANAGE_DISTRICT = "/epms/api/v1/admin/district/manage";
export const ADD_DISTRICT = "/epms/api/v1/admin/district";
export const EDIT_DISTRICT = "/epms/api/v1/admin/district";
export const GET_ALL_TALUKA_SEARCH = "/epms/api/v1/admin/taluka/search";
export const GET_ALL_TALUKA = "/epms/api/v1/admin/taluka";
export const GET_TALUKA = "/epms/api/v1/admin/taluka";
export const GET_TALUKA_STATES = "/epms/api/v1/admin/states";
export const GET_TALUKA_DISTRICTS = "/epms/api/v1/admin/districts";
export const MANAGE_TALUKA = "/epms/api/v1/admin/taluka/manage";
export const ADD_TALUKA = "/epms/api/v1/admin/taluka/";
export const EDIT_TALUKA = "/epms/api/v1/admin/taluka/";
export const GET_ALL_VILLAGE_SEARCH = "/epms/api/v1/admin/searchvillage";
export const GET_ALL_VILLAGE_SUBDIST = "/epms/api/v1/admin/getallvillages";
export const GET_ALL_VILLAGE = "/epms/api/v1/admin/getallvillages";
export const GET_VILLAGE = "/epms/api/v1/admin/village";
export const GET_VILLAGE_STATES = "/epms/api/v1/admin/states";
export const GET_VILLAGE_DISTRICTS = "/epms/api/v1/admin/districts";
export const GET_VILLAGE_TALUKAS = "/epms/api/v1/admin/taluka/bydistrict";
export const MANAGE_VILLAGE = "/epms/api/v1/admin/managevillage";
export const ADD_VILLAGE = "/epms/api/v1/admin/village";
export const EDIT_VILLAGE = "/epms/api/v1/admin/village";
export const GET_ALL_STAGE_SEARCH = "/epms/api/v1/admin/stages/search";
export const GET_ALL_STAGES = "/epms/api/v1/admin/stages";
export const GET_STAGE_BY_ID = "/epms/api/v1/admin/stage";
export const MANAGE_STAGE = "/epms/api/v1/admin/stage/manage";
export const ADD_STAGE = "/epms/api/v1/admin/stage";
export const EDIT_STAGE = "/epms/api/v1/admin/stage";
export const GET_ALL_STATES_LIST_FOR_DROPDOWN = "/epms/api/v1/admin/states";
export const GET_ALL_DISTRICTS_LIST_FOR_DROPDOWN =
  "/epms/api/v1/admin/districts";
export const GET_ALL_SUBDISTRICTS_LIST_FOR_DROPDOWN =
  "/epms/api/v1/admin/taluka/bydistrict";
export const GET_ALL_VILLAGES_LIST_FOR_DROPDOWN = "/epms/api/v1/admin/villages";
export const GET_ALL_EXAM_MODES_LIST_FOR_DROPDOWN =
  "/epms/api/v1/admin/lookupoption/bytype";
export const GET_ALL_COORDINATOR_ROLES_LIST_FOR_DROPDOWN =
  "/epms/api/v1/admin/venuemanagement/roles";
export const GET_ALL_COORDINATOR_GENDERS_LIST_FOR_DROPDOWN =
  "/epms/api/v1/admin/lookupoption/bytype";
export const GET_ALL_UNAPPROVAL_ENTITY_LIST =
  "/epms/api/v1/admin/entityapprovalaction";
export const ENTITY_APPROVAL = "/epms/api/v1/admin/entityapproval";
export const OBJECTIVE_STATUS_LOCK_UNLOCK = "/epms/api/v1/admin/lockunlock";
export const GET_GROUP_NAMES_FOR_COMBO = "/epms/api/v1/admin/lookupoptions";
export const GET_EXAM_TYPES_FOR_COMBO = "/epms/api/v1/admin/lookupoptions";
export const GET_DATE_RANGE = "/epms/api/v1/admin/fetchdaterange";
export const GET_ALL_REQUISITION_LOOKUP_OPTION_DROPDOWN =
  "/epms/api/v1/admin/lookupoptions";
export const GETEXAM_TYPES_FOR_COMBO = "/epms/api/v1/admin/lookupoptions";
export const GETGROUP_NAMES_FOR_COMBO = "/epms/api/v1/admin/lookupoptions";
export const GETRECRUITMENT_TYPES_FOR_COMBO =
  "/epms/api/v1/admin/lookupoptions";
export const GET_APPLICATION_DETAILS_BY_ID = "/epms/api/v1/admin/applications";
export const PROFILE = "/epms/api/v1/admin/profile";
export const CANDIDATE_PROFILE_INFO_DISPLAY =
  "/epms/api/v1/admin/profilecreationdraft";
export const GETALLEXAMLIST = "/epms/api/v1/admin/exams";
export const GETALLEXAMSBYADVTID = "/epms/api/v1/admin/exambyadvtid";
export const GETADVERTISEMENTBYEAR = "/epms/api/v1/admin/advertisements"
export const GETYEARLIST = "/epms/api/v1/admin/years";
export const UPLOADANSWERKEYDATA = "/epms/api/v1/admin/storeanswerkeys";
export const GETALLSUBJECTSBYEXAMID = "/epms/api/v1/admin/examsubjects";
export const GET_ALL_SUPERVISORS_BY_EXAM_AND_SUBJECT_ID =
  "/epms/api/v1/admin/supervisors";
export const CROSSCHECKCOUNT = "/epms/api/v1/admin/crosscheckcount/admitcard";
export const DOWNLOADCROSSCHECKCOUNT =
  "/epms/api/v1/admin/crosscheckcount/admitcard";
export const UPLOADSCANNEDDATA = "/epms/api/v1/admin/importscanneddata";
export const UPLOADINTERVIEWDATA = "/epms/api/v1/admin/storeinterviewmarks";
export const UPLOADPOSTDATA = "/epms/api/v1/admin/uploadcsv";
export const UPLOADEXAMDATA = "/epms/api/v1/admin/storeexam";
export const UPLOADADVERTISEMENTDATA = "/epms/api/v1/admin/storeadvertisements";
export const UPLOADMASTERDATA = "/epms/api/v1/admin/uploadcsv";
export const GETMASTERTYPES = "/epms/api/v1/admin/csvuploadconfig/master";
export const GETTRANSACTIOANALTYPES = "/epms/api/v1/admin/csvuploadconfig/transactional-data";
export const GETALLTYPES =
  "/epms/api/v1/admin/csvuploadconfig/advertiment-post-exam-data";
export const UPLOAD_TRANSACTIONAL_ANSWER_KEY_DATA = "/epms/api/v1/admin/uploadanswerkey";


export const GET_ALL_USERS_BY_ROLE_ID = "/epms/api/v1/admin/users";
export const GET_ALL_MODULES = "/epms/api/v1/admin/allmodule";
export const GET_ALL_SUB_MODULES_BY_MODULE_ID = "/epms/api/v1/admin/submodule";
export const MANAGE_ACCESS_TO_USER = "/epms/api/v1/admin/assignmodules";
export const GETALLANSWERKEYDATA = "/epms/api/v1/admin/answerkeydata/";
export const STOREANSWERKEY = "/epms/api/v1/admin/storeanswerkey";
export const UPDATE_DUPLICATE_ROLL_NO = "/epms/api/v1/admin/duplicates/approval";
export const UPDATE_OUT_OF_RANGE = "/epms/api/v1/admin/outofranges/approval";
export const UPDATE_ABSENTEE = "/epms/api/v1/admin/objectiveabsentee/approval";
export const ANSWERKEYDATAFORAPPROVAL =
  "/epms/api/v1/admin/answerkeydataforapproval";
export const ENTITYAPPROVALACTION = "/epms/api/v1/admin/entityapprovalaction";
export const GET_EXAMINER_AND_MODERATOR_APPROVAL_LIST =
  "/epms/api/v1/admin/entityapprovalaction";
export const GET_ASSIGN_SUB_MODULES_BY_USER_MODULE_ID =
  "/epms/api/v1/admin/user";
export const GET_ANSWER_KEY_DATA_LIST = "/epms/api/v1/admin/rules/answerkey";
export const GET_ALL_QUESTION_SETS = "/epms/api/v1/admin/answerkey/getsets";
export const SAVEANSWERRULES = "/epms/api/v1/admin/rules/answerkey";
export const GETRULESAPPROVALACTION = "/epms/api/v1/admin/entityapprovalaction";
export const GET_ALL_ROLL_NUMBER_LIST_BY_EXAMSUBJECT_ID =
  "/epms/api/v1/admin/rules/answerkey/rollnumbers";
export const GET_RULES_CALCULATE_RESULT =
  "/epms/api/v1/admin/rules/answerkey/calculateresult";
export const GET_OBJECTIVE_STATUS =
  "/epms/api/v1/admin/getobjectivestatus";
export const ABSENTEEOBJLIST = "/epms/api/v1/admin/objectiveabsentee";
export const DUPLICATES = "/epms/api/v1/admin/duplicates";
export const OUT_OF_RANGE = "/epms/api/v1/admin/outofranges";
export const ABSENTEELIST = "/epms/api/v1/admin/absenteelist";
export const GET_ALL_CATEGORIES = "/epms/api/v1/admin/categories";
export const GET_ALL_SUBCATEGORIES = "/epms/api/v1/admin/subcategories";
export const SAVE_QUALIFICATION_CUTOFF_DATA =
  "/epms/api/v1/admin/qualificationcriteria";
export const GET_ALL_EXAMINERS_REPORT_DATA = "/epms/api/v1/admin/marks/getallrecheckingmark/downloadcsv/";
export const UPDATE_ALL_EXAMINERS_REPORT_DATA = "/epms/api/v1/admin/marks";
export const GET_DIFFERENTIAL_REPORT_DATA =
  "/epms/api/v1/admin/marks/differential/";
export const UPLOAD_MARKS_CSV = "/epms/api/v1/admin/uploadbarcodemarkscsv";
export const GET_RESERVATION_DATA = "/epms/api/v1/admin/qualificationcriteria";
export const LOCK_UNLOCK_STATUS = "/epms/api/v1/admin/marks/lockunlock";
export const GET_INTERVIEW_ATTENDEE_LIST = "/epms/api/v1/admin/attendee";
export const GET_INTERVIEW_ABSENTEE_LIST = "/epms/api/v1/admin/absentee";
export const GETCUTOFFLIST = "/epms/api/v1/admin/qualificationcriteria";
export const GETQUALIFYINGLIST = "/epms/api/v1/admin/qualifiedcandidates";
export const GET_INTERVIEW_QUALIFIED_CANDIDATE_DATA =
  "/epms/api/v1/admin/interviewletters";
export const GET_INTERVIEW_QUALIFIED_CANDIDATE_LIST =
  "/epms/api/v1/admin/interviewletterslist";
export const GET_VENUE_LIST = "/epms/api/v1/admin/getvenue";
export const GET_ALL_MARKS_FOR_PDF = "/epms/api/v1/admin/marks/differential";
export const GETINTERVIEWLIST = "/epms/api/v1/admin/interviewschedule";
export const IMPORT_INTERVIEW_MARKS = "/epms/api/v1/admin/storeinterviewmarks";
export const GET_INTERVIEW_MARKS_LIST = "/epms/api/v1/admin/interviewmarks";
export const POST_INTERVIEW_MARKS_FOR_APPROVAL = "/epms/api/v1/admin/interviewmarks/approval";
export const GET_ALL_UNAPPROVAL_INTERVIEW_LIST = "/epms/api/v1/admin/entityapprovalaction"
export const UPDATE_INTERVIEW_MARKS = "/epms/api/v1/admin/interviewmarks/approval";
export const GET_VERSION_MISMATCH_LIST = "/epms/api/v1/admin/versionmismatch";
export const GET_INVIGILATOR_VERSION_MISMATCH_LIST = "/epms/api/v1/admin/versionmismatch/invigilator";
export const GET_UNAPPROVED_VERSION_MISMATCH_LIST = "/epms/api/v1/admin/entityapprovalaction";
export const UPDATE_VERION_MISMATCH_DATA = "/epms/api/v1/admin/versionmismatch/approval";
export const GETINTERVIEWMARKSTATEMENT = "/epms/api/v1/admin/interviewmarkstatement";
export const GETSTATISTICALREPORT = "/epms/api/v1/admin/recommendedcandidates";
export const UPLOAD_BARCODE_CSV = "/epms/api/v1/admin/uploadbarcoderollnocsv";
export const MARKS_CRITERIA = "/epms/api/v1/admin/marks/criteria"
export const SAVEQUALIFICATIONMULTIPLE = "/epms/api/v1/admin/qualificationmultiple";
export const GET_IMAGE = "/epms/api/v1/admin/getimage";
export const GETSTATISTICALPREABSREPORT = "/epms/api/v1/admin/presentabsentlist";
export const GET_TOTAL_STUDENTS = "/epms/api/v1/admin/totalmarkscount";
export const MARK_DIFFERENCE_COUNT = "/epms/api/v1/admin/chiefmoderator/candidatecount";
export const CHIEF_MODERATOR_MARK_CRITERIA = "/epms/api/v1/admin/chiefmoderator/marks/criteria";
export const MODERATOR_MARKS_COUNT = "/epms/api/v1/admin/moderator/mark/candidatecount";
export const MODERATOR_MARK_CRITERIA = "/epms/api/v1/admin/moderator/marks/criteria";
export const MODERATOR_CANDIDATE_LIST = "/epms/api/v1/admin/moderator/getcandidatelist/csvfile";
export const CHIEF_MODERATOR_CANDIDATE_LIST = "/epms/api/v1/admin/chiefmoderator/getcandidatelist/csvfile";
export const MODERATOR_PERCENTAGE_CRITERIA = "/epms/api/v1/admin/moderator/percentage/candidatecount";
export const GET_ATTENDANCE_SHEET = "/epms/api/v1/admin/attendancesheet";
export const CREATE_DEPARTMENT = "/epms/api/v1/admin/department";
export const GET_DEPARTMENT_LIST = "/epms/api/v1/admin/departments";
export const GET_STATISTICAL_DATA = "/epms/api/v1/admin/mainexamresultstatistics";
export const GET_POST_CRITERIA_BY_EXAM_ID = "/epms/api/v1/admin/postcriteria";
export const GET_CRITERIA_CHECKING_LIST = "/epms/api/v1/admin/criteriaforchecking";
export const ADD_NEW_USER = "/epms/api/v1/admin/adduser";
export const GET_USER_LIST = "/epms/api/v1/admin/allusers";
export const GET_USER_UNAPPROVED_DATA = "/epms/api/v1/admin/userapproval";
export const SET_APPROVALUSER = "/epms/api/v1/admin/approvaluser"
export const GET_DUPLICATES = "/epms/api/v1/admin/descriptive/duplicates";
export const CREATE_ROLE = "/epms/api/v1/admin/role";
export const GET_ROLE_LIST = "/epms/api/v1/admin/roles";
export const SEAT_MATRIX_LOCK_UNLOCK = "/epms/api/v1/admin/lockunlock";
export const CALCULATE_CUTOFF = "/epms/api/v1/admin/calculate/cutoff";
export const GET_GENERAL_SLAB_REPORT = "/epms/api/v1/admin/slab";
export const GET_USER = "/epms/api/v1/admin/users";
export const GET_POST_CRITERIA_STATISTICS = "/epms/api/v1/admin/statisticslist"
export const GET_ALL_APPLICATIONS = "/epms/api/v1/admin/getallapplication";
export const APPLICATION_APPROVAL = "/epms/api/v1/admin/application/approval";
export const INTREVIEW_MARKS_APPROVAL = "/epms/api/v1/admin/interview/marks/approval";
export const GET_APPLICATION_POST_PREF_LIST = "/epms/api/v1/admin/applicationpostpreflist";
export const APPLICATION_POST_APPROVAL = "/epms/api/v1/admin/applicationpostpref/approval";
export const GET_RETOTALING_LIST = "/epms/api/v1/admin/retotalingrequestlist";
export const RETOTALING_APPROVAL = "/epms/api/v1/admin/totalingrequest/approval";
export const GET_PREEXAMRESULT_ADVERTISEMENT = "/epms/api/v1/admin/preexamadvertisements";
export const GET_MAINEXAMRESULT_ADVERTISEMENT = "/epms/api/v1/admin/mainexamadvertisements";
export const GET_VIEW_MARKS = "/epms/api/v1/admin/rules/getresult";
export const GET_ALPHABETICAL_LIST = "/epms/api/v1/admin/alphabeticallist";
export const GET_DOWNLOAD_CANDIDATE_LIST = "/epms/api/v1/admin/qualifiedcandidatecsv";
export const SAVE_CREATE_INTERVIEW_LETTER = "/epms/api/v1/admin/createinterviewletters";
export const MODERATOR_CRITERIA_STATUS = "/epms/api/v1/admin/moderator/marks/criteriacheck";
export const CHIEF_MODERATOR_CRITERIA_STATUS = "/epms/api/v1/admin/chiefmoderator/marks/criteriacheck";
export const GET_ROLLNO_QUALIFIEDCANDIDATE = "/epms/api/v1/admin/qualifiedcandidaterollnumber"
export const GET_CUTOFF_CRITERA = "/epms/api/v1/admin/cutoff";
export const GET_UNLOCK_CUTOFF = "/epms/api/v1/admin/lockunlock";
export const GET_RESERVED_SEATS = "/epms/api/v1/admin/qualificationcriteria/reservedseats";
export const UPLOAD_PHYSICAL_TEST_MARKS = "/epms/api/v1/admin/physicaltestcsv"
export const GET_PHYSICAL_TEST_MARKS = "/epms/api/v1/admin/physical/marks";
export const PHYSICAL_TEST_MARKS_APPROVAL = "/epms/api/v1/admin/physicaltest/approval";
export const UPLOAD_MEDICAL_TEST_MARKS = "/epms/api/v1/admin/medicaltestcsv";
export const GET_MEDICAL_TEST_MARKS = "/epms/api/v1/admin/medical/marks";
export const MEDICAL_TEST_MARKS_APPROVAL = "/epms/api/v1/admin/medicaltest/approval";
export const GET_PENDING_ACTIVITIES = "/epms/api/v1/admin/pendingactivities";
export const GET_CURRENT_ACTIVITIES = "/epms/api/v1/admin/currentactivities";
export const GET_ALL_ACTIVITIES = "/epms/api/v1/admin/allactivities";
export const GET_ELIGIBLE_RECOMMANDATION_REPORT = "/epms/api/v1/admin/eligiblerecommendation";
export const GET_MERIT_LIST_REPORT = "/epms/api/v1/admin/meritlist";
export const DOWNLOAD_SAMPLE_FILE = "/epms/api/v1/admin/template"
export const GET_NEW_INTERVIEW_LIST = "/epms/api/v1/admin/interviewlist";
export const FLAG_ACCESS_STATUS = "/epms/api/v1/admin/getflgaccess";
export const INTERVIEW_POST_PREFERENCE = "/epms/api/v1/admin/interviewpostpreferenceslist";
export const ALLOTMENT_CHART_REPORT = "/epms/api/v1/admin/allotment/chart";
export const GET_RECOMMENDATION_REPORTS = "/epms/api/v1/admin/recommendationreports"
export const GET_ALL_BARCODE_AND_ROLLNO = "/epms/api/v1/admin/barcoderollno";
export const GET_DUPLICATE_CODE_NO = "/epms/api/v1/admin/duplicatecodeno/examiner/moderator/chiefmoderator";
export const SET_INTERVIEW_RECOMMENDATION = "/epms/api/v1/admin/interviewcriteria";
export const GET_QUALIFICATION_TYPE = "/epms/api/v1/admin/qualificationtype";
export const GET_QUALIFICATION_NAME_BY_TYPE = "/epms/api/v1/admin/qualificationname";
export const GET_EXPERIENCE = "/epms/api/v1/admin/lookupoptions";
export const GET_INTERVIEW_CRITERIA = "/epms/api/v1/admin/entityapprovalaction"
export const GET_INTERVIEW_CRITERIA_APPROVAL_ENTITY = "/epms/api/v1/admin/entityapproval";
export const SET_RECOMMENDATION_CRITERIA = "/epms/api/v1/admin/recommendationcriteria";
export const GET_RECOMMENDATION_CRITERIA = "/epms/api/v1/admin/entityapprovalaction";
export const GET_RECOMMENDATION_CRITERIA_APPROVAL_ENTITY = "/epms/api/v1/admin/entityapproval";
export const MODERATOR_MODERATION_NOT_DONE = "/epms/api/v1/admin/moderationnotdone/moderator";
export const CHIEF_MODERATOR_MODERATION_NOT_DONE = "/epms/api/v1/admin/chiefmoderationnotdone/chiefmoderator";
export const GET_RECOMMENDATION_CUTOFF = "/epms/api/v1/admin/recommendationcutoff";
export const GET_INTERVIEW_REPORTS_QUALIFIED = "/epms/api/v1/admin/interview/generatequalified"
export const GET_REPORTS_QUALIFIED_CANDIDATE = "/epms/api/v1/admin/recommendationreports";
export const GET_RECOMMENDATION_CALCULATE_QUALIFIED = "/epms/api/v1/admin/generate/recommendationcutoff"
export const GET_RECOMMENDATION_VIGATVARI = "/epms/api/v1/admin/recommendationvigatvari";
export const GET_ADMITED_CANDIDATE_LIST = "/epms/api/v1/admin/statistics/admitted";
export const GET_QUALIFIED_CANDIDATE_LIST = "/epms/api/v1/admin/statistics/qualified";
export const GET_INTERVIEWED_CANDIDATE_LIST = "/epms/api/v1/admin/statistics/interviewed";
export const GET_MERITORIOUS_CANDIDATE_LIST = "/epms/api/v1/admin/statistics/meritorious";
export const GET_PRESENT_CANDIDATE_LIST = "/epms/api/v1/admin/statistics/present";
export const GET_SUBJECT_CODE_ROLLNO = "/epms/api/v1/admin/subjectcoderollno";
export const GET_EXAM_CODE_ROLLNO = "/epms/api/v1/admin/examcoderollno";
export const GET_INTERVIEW_SCHEDULE = "/epms/api/v1/admin/interviewschedulelist";
export const GET_INTERVIEW_CRITERIA_DATA = "/epms/api/v1/admin/interviewcriteria";
export const SET_UPDATE_INTERVIEW_CRITERIA = "/epms/api/v1/admin/interviewcriteria";
export const GET_RECOMMENDATION_CRITERIA_DATA = "/epms/api/v1/admin/recommendationcriteria";
export const GET_OBJECTIVE_STATUS_FLAG = "/epms/api/v1/admin/getstatusflags";
export const SET_UPDATE_RECOMMENDATION_CRITERIA = "/epms/api/v1/admin/recommendationcriteria";
export const GET_REVISED_INTERVIEW_SCHEDULE = "/epms/api/v1/admin/revisedinterviewschedule";
export const UPDATE_INTERVIEW_LETTER = "/epms/api/v1/admin/updateinterviewletters";
export const GET_INTERVIEW_LETTER = "/epms/api/v1/admin/interviewletter";
export const GET_MODULE_SUBMODULE = "/epms/api/v1/admin/module/submodule";
export const GET_USER_UPDATE_ID = "/epms/api/v1/admin/getmoduleaccess";
export const GET_USER_DEPT_ROLES = "/epms/api/v1/admin/users";
export const GET_ALL_USER_ROLES = "/epms/api/v1/admin/userroles";
export const START_FILE_UPLOAD = "/epms/api/v1/admin/startfileupload";
export const FILE_UPLOAD_STATUS = "/epms/api/v1/admin/filestatus";
export const DOWNLOAD_ERROR_FILE = "/epms/api/v1/admin/downloaderrorfile";
export const ANSWER_KEY_SET_LIST = "/epms/api/v1/admin/rules/answerkeyset";
// export const SAVE_RESULT_FLOW = "/epms/api/v1/admin/exam-flow/configure";
export const SAVE_RESULT_FLOW = "/epms/api/v1/admin/saveinfo";
export const SET_POST_LIST ="/epms/api/v1/admin/fetchpostcriterias";
export const FETCH_SUBJECTS_BY_EXAM_AND_POST ="/epms/api/v1/admin/fetchsubjects";
export const GET_CHECK_QUALIFIED_LIST="/epms/api/v1/admin/checkqualified";
export const EXAM_TYPE_LOOKUPOPTION="/epms/api/v1/admin/lookupoptions";
export const GET_SAVE_INFO="/epms/api/v1/admin/getinfo";
export const GET_FINAL_RESULT_LIST = "/epms/api/v1/admin/calculate/result";
export const GET_CUTOFF_SUMMARY = "/epms/api/v1/admin/cutoff-summary";
export const GET_ADVERTISEMENT_RESULT_FLOW = "/epms/api/v1/admin/advertisementsresultflow";
export const GET_RESULT_FLOW_YEARS = "/epms/api/v1/admin/advertisements/yearsfromexamflow";
export const GET_RESULT_FLOW_ADVERTISEMENT_BY_YEAR = "/epms/api/v1/admin/advertisementsresultflow";
export const EXAM_NAME = "/epms/api/v1/admin/examname";